<template>
    <div class="xieyi_fenlei">
        <div class="xieyi_neirong">
            <p class="biaoti-xieyi">《酷皮音乐用户协议》</p>
            <div class="wenzi_zhenduo">

                一、协议的接受与修改<br />

                1.当你使用酷皮音乐的服务（以下简称 “本服务”）时，即表示你已阅读、理解并同意接受本用户协议的所有条款和条件。如果你不同意本协议的任何部分，请立即停止使用本服务。
                <br />2.酷皮音乐有权在必要时修改本协议的条款和条件，修改后的协议将在酷皮音乐平台上公布。你继续使用本服务将被视为接受修改后的协议。请定期查看本协议的更新信息。
                <br />
                <br />二、服务内容

                <br />1.酷皮音乐向用户提供在线音乐播放、音乐搜索、音乐下载（部分歌曲根据版权限制可能仅支持在线播放）、歌单创建、音乐推荐等服务，旨在为用户提供优质的音乐体验。
                <br />2.酷皮音乐将尽力确保服务的稳定性和可靠性，但不保证服务不会中断或出现错误。在服务维护、升级、不可抗力或其他合理情况下，服务可能会暂时不可用，酷皮音乐不对此承担责任。
                <br /><br />三、用户账户

                <br />1.用户需要注册酷皮音乐账户才能使用部分服务，在注册时应提供准确、完整的个人信息，并对该信息的真实性负责。
                <br />2.你应妥善保管自己的账户和密码，不得将账户转让或借给他人使用。因你自身的原因导致账户泄露、丢失或被盗用而产生的一切后果由你自行承担。
                <br />3.酷皮音乐有权在发现用户违反本协议或法律法规的情况下，暂停或终止用户账户的使用，而无需事先通知用户。
                <br /><br />四、用户行为规范

                <br />1.你使用本服务时，不得从事以下行为：
                <br />1.利用本服务从事任何违法犯罪活动，包括但不限于传播淫秽、恐怖、暴力、赌博、诈骗等信息。
                <br />2.侵犯他人的知识产权，如未经授权上传、传播受版权保护的音乐作品或其他资料。
                <br />3.干扰、破坏本服务的正常运行，包括但不限于使用恶意软件、攻击服务器、篡改数据等行为。
                <br />4.以任何方式对本服务进行反向工程、破解或试图获取源代码。
                <br />5.对其他用户进行骚扰、辱骂、威胁或侵犯其他用户的合法权益。
                <br />2.若酷皮音乐发现你有上述行为，有权采取包括但不限于警告、暂停或终止服务、删除违规内容、向有关部门举报等措施，你需对自己的行为承担相应的法律责任。
                <br /><br />五、知识产权

                <br />1.酷皮音乐平台上的所有音乐作品、软件、界面设计、商标、标识等均受知识产权法律法规的保护，归酷皮音乐或其授权方所有。未经酷皮音乐或相关权利人的许可，你不得擅自使用、复制、传播或进行商业开发。
                <br />2.对于用户在酷皮音乐平台上创建的歌单、评论等内容，用户授予酷皮音乐全球范围内的、免费的、非独占的、可再许可的许可，使酷皮音乐可以使用、复制、修改、展示、分发这些内容，用于提供和改进本服务。
                <br />六、隐私保护

                <br />1.酷皮音乐尊重和保护用户的隐私，将根据相关法律法规和本协议的规定处理用户的个人信息。具体隐私政策请查看酷皮音乐的隐私声明。
                <br />2.酷皮音乐可能会收集和使用你的信息，包括但不限于用户的注册信息、使用记录、设备信息等，以便为你提供更好的服务和改善用户体验。酷皮音乐将采取合理的安全措施保护用户信息，但不保证信息的绝对安全，因不可控因素导致信息泄露的，酷皮音乐将尽力协助解决，但不承担全部责任。
                <br /><br />七、付费服务

                <br />1.酷皮音乐可能提供部分付费服务，包括但不限于购买歌曲、购买会员服务等。你在使用付费服务前，应仔细阅读并确认相应的价格、服务内容和支付条款。
                <br />2.付费服务一经购买，除法律规定或酷皮音乐另有规定外，通常不支持退款。请谨慎选择付费服务。
                <br /><br />八、广告和第三方服务

                <br />1.酷皮音乐可能会在服务中展示广告，你理解并同意接受这些广告。你点击广告后可能会跳转到第三方网站，对于第三方网站的内容和服务，酷皮音乐不承担任何责任。
                <br />2.酷皮音乐可能会与第三方服务提供商合作，为用户提供部分服务或功能。你使用第三方服务时，需遵守第三方的服务条款，因第三方服务引起的任何纠纷或问题，酷皮音乐不承担责任。
                <br /><br />九、免责声明

                <br />1.酷皮音乐仅作为音乐服务的提供者，不保证用户使用服务所获得的结果符合其预期，也不保证服务内容的准确性、完整性、及时性或可靠性。
                <br />2.在任何情况下，酷皮音乐对因使用或无法使用本服务而导致的直接、间接、偶然、特殊、后果性或惩罚性的损害（包括但不限于数据丢失、利润损失、业务中断等）不承担责任，即使酷皮音乐已被告知可能发生此类损害。
                <br /><br />十、适用法律和争议解决

                <br />1.本协议的解释、效力和履行受 [具体适用法律] 的管辖。
                <br />2.如因本协议或使用本服务产生争议，双方应首先友好协商解决；协商不成的，可向有管辖权的法院提起诉讼。
                <br /><br />十一、其他条款

                <br />1.本协议构成你与酷皮音乐之间关于使用本服务的完整协议，取代之前的任何协议或谅解。
                <br />2.若本协议的部分条款被认定为无效或不可执行，不影响其他条款的有效性和可执行性。



            </div>
        </div>
    </div>
</template>
<script>
// 服务协议
export default {

}
</script>
<style lang="scss" scoped>
.xieyi_fenlei {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .xieyi_neirong {
        width: 1200px;
        // background-color: antiquewhite;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .biaoti-xieyi {
            font-size: 23px;
            font-family: YuanTi;
            font-weight: bold;
            margin-bottom: 20px;
            color: var(--them-color);
        }

        .wenzi_zhenduo {
            font-size: 16px;
            font-family: YuanTi;
            color: var(--xieyi-size);
            line-height: 33px;
            padding-bottom: 20px;
            white-space: pre-wrap;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
}
</style>